// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"5e95977f8cc03fe4ff3b","293":"fdd300e8b868b12bcb1d","518":"dde9810a52e34543dac3","779":"cfc9b21ca282a3ba612e"}[chunkId] + ".js";
};